export default function SideTabs({
  sides, active, onSelect,
}: {
  sides: { label: string }[]
  active: number
  onSelect: (i: number) => void
}) {
  if (sides.length <= 1) return null
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
      {sides.map((s, i) => (
        <button
          key={i}
          onClick={() => onSelect(i)}
          style={{
            padding: '10px 14px', borderRadius: 50, cursor: 'pointer',
            fontSize: 13, fontWeight: 500, minHeight: 44,
            border: `1px solid ${i === active ? 'var(--accent)' : 'var(--border)'}`,
            background: i === active ? 'var(--accent-soft)' : 'transparent',
            color: i === active ? 'var(--accent)' : 'var(--text-secondary)',
            transition: 'all 0.15s',
          }}
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
